<script lang="ts">
  // A setting row: label and description, and a switch that saves as soon as it's flipped. `save`
  // answers whether the change was saved; the switch flips back when it wasn't.
  import { Switch } from '$lib/components/ui/switch'

  export let id: string
  export let label: string
  export let description = ''
  export let checked = false
  export let disabled = false
  export let save: (checked: boolean) => Promise<boolean>

  let saving = false
  $: described = !!description || !!$$slots.default

  async function change(value: boolean | undefined) {
    if (saving) return
    saving = true
    const ok = await save(!!value)
    saving = false
    if (!ok) checked = !value
  }
</script>

<div class="flex items-start justify-between gap-4 py-3">
  <div class="flex min-w-0 flex-col gap-0.5">
    <label for={id} class="m-0 cursor-pointer text-sm font-medium leading-snug text-foreground">{label}</label>
    {#if described}
      <p id="{id}-description" class="m-0 text-xs font-normal leading-snug text-muted-foreground">{description}<slot /></p>
    {/if}
  </div>
  <span class="flex shrink-0 items-center gap-2 pt-0.5">
    {#if saving}<i class="fa-solid fa-spinner-third fa-spin text-xs text-muted-foreground" aria-hidden="true" />{/if}
    <Switch {id} bind:checked onCheckedChange={change} disabled={disabled || saving} aria-describedby={described ? `${id}-description` : undefined} />
  </span>
</div>
